import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupExamCollection(): void {
  applicationModuleRegistry.register({
    entry: 'EXAM_COLLECT#9130',
    id: 'EXAM_COLLECT#9130',
    name: 'module.exam-collection',
    route: ApplicationRoute.EXAM_COLLECTION,
    routes: [
      {
        main: true,
        name: 'function.list-of-patients',
        route: ApplicationRoute.SEARCH_PATIENT,
      }
    ]
  });
}
